/// <amd-module name="SuiteCommerce.GiftCertificate.Item.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.Item.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemModel = void 0;
    var ItemModel = /** @class */ (function (_super) {
        __extends(ItemModel, _super);
        function ItemModel(attributes, options) {
            var _this = _super.call(this, attributes, options) || this;
            if (attributes.id) {
                _this.set('internalid', attributes.id);
            }
            return _this;
        }
        Object.defineProperty(ItemModel.prototype, "id", {
            get: function () {
                return this.get('internalid');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "price", {
            get: function () {
                return parseInt(this.get('onlinecustomerprice'), 10);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "priceStr", {
            get: function () {
                return this.get('onlinecustomerprice');
            },
            enumerable: false,
            configurable: true
        });
        return ItemModel;
    }(Backbone_1.Model));
    exports.ItemModel = ItemModel;
});
